document.addEventListener('DOMContentLoaded', function () {
    var elements = document.querySelectorAll('.manitoba-chiffres-animated-number-value');

    if (!elements.length) return;

    if (typeof IntersectionObserver === 'undefined') {
        elements.forEach(function (el) {
            el.classList.add('is-visible');
        });
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 });

    elements.forEach(function (el) {
        observer.observe(el);
    });
});
